var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentParam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5.33185C-0.166667 4.94695 -0.166666 3.98469 0.5 3.59979L6.5 0.135694C7.16667 -0.249207 8 0.231919 8 1.00172V7.92992C8 8.69972 7.16667 9.18085 6.5 8.79595L0.5 5.33185Z",
    fill: "#7ACDF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentParam);
export default __webpack_public_path__ + "static/media/currentParam.35cff9d14a25afc3709eb64104e41e40.svg";
export { ForwardRef as ReactComponent };